.drawer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
  z-index: 10;
  max-height: 50vh;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.title {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.tempoLabel {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
}

@media (max-width: 640px) {
  .drawer {
    max-height: 75vh;
  }
}
